import { SVGProps } from 'react'

const NewStudents = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.4757 23.678C23.4244 23.678 25.8147 21.2876 25.8147 18.339C25.8147 15.3904 23.4244 13 20.4757 13C17.5271 13 15.1367 15.3904 15.1367 18.339C15.1367 21.2876 17.5271 23.678 20.4757 23.678Z"
        fill="#7181FF"
      />
      <path
        d="M20.4785 25.3555C16.0743 25.3609 12.5054 28.9352 12.5 33.346C12.5 33.8363 12.8969 34.2338 13.3865 34.2338H27.5705C28.0601 34.2338 28.457 33.8363 28.457 33.346C28.4517 28.9352 24.8827 25.3609 20.4785 25.3555Z"
        fill="#7181FF"
      />
      <path
        d="M34.5006 20.6367C33.3423 20.6944 32.4485 21.6776 32.5011 22.8361C32.5537 21.6776 31.66 20.6944 30.5017 20.6367C29.3434 20.6944 28.4496 21.6776 28.5022 22.8361C28.5022 24.5656 30.7576 26.592 31.8813 27.4938C32.2436 27.7839 32.7586 27.7839 33.1209 27.4938C34.2446 26.594 36.5 24.5656 36.5 22.8361C36.5527 21.6775 35.6589 20.6944 34.5006 20.6367Z"
        fill="#7181FF"
      />
    </svg>
  )
}

export default NewStudents
